import { create } from 'zustand'

export interface UkstrTask {
  id: string
  nomor: string
  sumber: string
  pemberi: string
  klasifikasi: string
  tanggal: string
  batasWaktu: string
  wilayah: string
  isuStrategis: string
  uraian: string
  lampiran: string[]

  // AI Generated / Edited
  judul: string
  dasar: string
  sasaran: string
  eei: string
  rencana: string
  analisisRisiko: string
  mekanisme: string
  koordinasi: string
  saran: string
  otentikasi: string

  status:
    | 'Draft'
    | 'Menunggu Persetujuan'
    | 'Disetujui'
    | 'Diterbitkan'
    | 'Dalam Pengumpulan'
    | 'Jawaban Masuk'
    | 'Dianalisis'
    | 'Selesai'
  target: string[]
}

export interface UkstrAnswer {
  id: string
  taskId: string
  personelId: string
  personelName: string
  wilayah: string
  waktu: string
  ringkasan: string
  uraian: string
  kronologi: string
  pihakTerkait: string
  lokasi: string
  lampiran: string[]
  catatan: string
  status:
    | 'Dikirim'
    | 'Diterima BINDA'
    | 'Diverifikasi'
    | 'Digunakan dalam Laporan'
    | 'Selesai'
}

interface UkstrState {
  tasks: UkstrTask[]
  answers: UkstrAnswer[]

  createTask: (task: Omit<UkstrTask, 'id' | 'status'>) => void
  updateTask: (id: string, updates: Partial<UkstrTask>) => void
  submitAnswer: (answer: Omit<UkstrAnswer, 'id' | 'status' | 'waktu'>) => void
  updateAnswerStatus: (id: string, status: UkstrAnswer['status']) => void
}

export const useUkstrStore = create<UkstrState>((set) => ({
  tasks: [
    {
      id: 'UKSTR-2023-001',
      nomor: 'STR/001/X/2023',
      sumber: 'Arahan Pimpinan',
      pemberi: 'Kepala BIN',
      klasifikasi: 'SANGAT RAHASIA',
      tanggal: '2023-10-28',
      batasWaktu: '2023-11-05',
      wilayah: 'Nasional',
      isuStrategis: 'Potensi Gangguan Keamanan Jelang Pemilu',
      uraian:
        'Lakukan deteksi dini terhadap kelompok radikal yang berpotensi mengganggu tahapan pemilu.',
      lampiran: [],
      judul: 'Deteksi Dini Kelompok Radikal Jelang Pemilu 2024',
      dasar: 'A. UU No 17 Tahun 2011\nB. Arahan Kepala BIN',
      sasaran: 'A. Kelompok Radikal X\nB. Wilayah Rawan Konflik',
      eei: '1. Siapa tokoh penggerak?\n2. Apa sumber pendanaan?',
      rencana: 'A. HUMINT: Infiltrasi\nB. OSINT: Pemantauan Medsos',
      analisisRisiko: 'Risiko eksposur agen tinggi di wilayah X.',
      mekanisme: 'Pelaporan harian via DENS CAKRA.',
      koordinasi: 'Koordinasi dengan aparat keamanan setempat.',
      saran: 'Tingkatkan pengamanan di titik rawan.',
      otentikasi: 'Analis Nasional',
      status: 'Diterbitkan',
      target: ['Semua BINDA'],
    },
  ],
  answers: [
    {
      id: 'ANS-001',
      taskId: 'UKSTR-2023-001',
      personelId: 'PL-001',
      personelName: 'Agen Alpha',
      wilayah: 'DKI Jakarta',
      waktu: '2023-10-29 10:00',
      ringkasan: 'Terpantau pertemuan tertutup kelompok X.',
      uraian: 'Pertemuan dihadiri 20 orang membahas rencana aksi.',
      kronologi: '08:00 Massa berkumpul. 09:00 Rapat dimulai.',
      pihakTerkait: 'Tokoh A, Tokoh B',
      lokasi: 'Jakarta Pusat',
      lampiran: ['foto_rapat.jpg'],
      catatan: 'Perlu pemantauan lanjutan.',
      status: 'Dikirim',
    },
  ],

  createTask: (task) =>
    set((state) => ({
      tasks: [
        { ...task, id: `UKSTR-${Date.now()}`, status: 'Draft' },
        ...state.tasks,
      ],
    })),

  updateTask: (id, updates) =>
    set((state) => ({
      tasks: state.tasks.map((t) => (t.id === id ? { ...t, ...updates } : t)),
    })),

  submitAnswer: (answer) =>
    set((state) => ({
      answers: [
        {
          ...answer,
          id: `ANS-${Date.now()}`,
          waktu: new Date().toISOString().replace('T', ' ').substring(0, 16),
          status: 'Dikirim',
        },
        ...state.answers,
      ],
    })),

  updateAnswerStatus: (id, status) =>
    set((state) => ({
      answers: state.answers.map((a) => (a.id === id ? { ...a, status } : a)),
    })),
}))
